import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';
import storageService from '@shared/storage/storageService';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from '@app/auth/components/change-password/change-password.component';

@Component({
  selector: 'dashboardfooter',
  templateUrl: './dashboardfooter.component.html',
  styleUrls: ['./dashboardfooter.component.scss']
})
export class DashBoardFooterComponent implements OnInit {
  isComponent=""
  subscription: any;
  currentUser: any;

  constructor(
    private router:Router,
    private broadCast:BroadCastServiceService,
    public dialog: MatDialog)
   {
 }
 
  ngOnInit() {
    this.currentUser = storageService.getItemAsJSON("currentUser")
    this.subscription = this.broadCast
		.getMessage()
		.subscribe((message) => {
		  if (message)  {
		   this.isComponent=message;
		  }
		});
  }
  // logout and change pwd modal
  logout(){
    storageService.clearItem('token');
    this.router.navigate(['landing-page']);
   }
 
   openChangePwdModel(){
   this.dialog.open(ChangePasswordComponent);
   }
}
